import { AxiosError } from 'axios'

import { http } from './client'

import { useSessionStore } from '@/app/store/auth/auth.store'

http.interceptors.request.use((config) => {
    const token = useSessionStore.getState().token

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

http.interceptors.response.use(
    (response) => response,

    (error: AxiosError) => {
        if (error.response?.status === 401) {
            useSessionStore.getState().logout()
        }

        return Promise.reject(error)
    }
)